"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var PROGRESS_BAR_STYLES = "absolute top-0 left-0 flex p-1 bg-gray-400 bg-opacity-25 w-full rounded";
var METER_STYLES = "flex bg-lochivar-default rounded";
var Progress = function (_a) {
    var _b = _a.progress, progress = _b === void 0 ? 0 : _b;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: PROGRESS_BAR_STYLES }, { children: [(0, jsx_runtime_1.jsx)("span", { className: METER_STYLES, style: { width: (progress !== null && progress !== void 0 ? progress : 0) + "%", height: "4px" } }, void 0), (0, jsx_runtime_1.jsx)("progress", { max: "100", value: progress, className: "absolute opacity-0" }, void 0)] }), void 0));
};
exports.Progress = Progress;
